import { Box, Paper, Typography } from "@mui/material"
import Chatbot from "./Chatbot"

export default function ChatbotPage() {
  return (
    <Box sx={{ px: 2, py: 4, maxWidth: 800, mx: "auto" }}>
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          About this chatbot
        </Typography>
        <Typography variant="body1">
          Hi! My name is Jennifer and I spent two months in Boston in spring 2025 as part of the ZHAW-Swissnex Staff Mobility Program. 
          To help future travelers, visitors, or fellows at Swissnex Boston, I created this chatbot. 
          It answers the questions I had (and wish I’d asked) - from housing and public transport 
          to local tips. Enjoy!
        </Typography>
      </Paper>

      <Chatbot />
    </Box>
  )
}
